import React from 'react'
import {ShowGuesser} from '@api-platform/admin'
import {TextField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
        </ShowGuesser>
    )
}

export default Show
